/**
 * Les refus de champ de Laravel (422 : `{ message, errors: { champ: [phrases] } }`, rangé tel quel
 * dans la tranche par `apiRequest`) : la première phrase de chaque champ, sous sa clé d'API, dans
 * l'ordre du serveur. Chaque formulaire range ensuite ces clés sous ses propres champs.
 */
export function laravelFieldErrors(error: unknown): Record<string, string> {
    const errors = (error as { errors?: unknown } | null | undefined)?.errors
    const fields: Record<string, string> = {}
    if (!errors || typeof errors !== "object") return fields
    for (const [key, messages] of Object.entries(errors as Record<string, unknown>)) {
        fields[key] = Array.isArray(messages) ? String(messages[0] ?? "") : String(messages ?? "")
    }
    return fields
}
